module.exports = __webpack_public_path__ + "img/industry_solution6.02b22dd8.png";